import * as React from 'react';
import { Text } from '@doordash/design-language';
import Toggle from '@doordash/component-toggle';
import { OptionTileContainer, OptionImg } from '../QuizStyles';
export var OptionTile = function (_a) {
    var isSelected = _a.isSelected, id = _a.id, title = _a.title, subtitle = _a.subtitle, imageUrl = _a.imageUrl, onSelect = _a.onSelect;
    return (React.createElement(OptionTileContainer, { onClick: function () { return onSelect(id); } },
        React.createElement("div", null,
            React.createElement(Toggle, { type: Toggle.Types.Radio, onClick: function () { return onSelect(id); }, isSelected: isSelected })),
        React.createElement(Text, { styles: Text.Styles.Title2 }, title),
        subtitle && (React.createElement(Text, { styles: Text.Styles.Body2, color: Text.Colors.TextSecondary }, subtitle)),
        imageUrl && React.createElement(OptionImg, { src: imageUrl })));
};
